<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\myCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào [Khóa học của tôi] trên thanh tiêu đề, thì tất cả các khóa học mà bạn là học viên sẽ được hiển thị.</p>
                    <p>② Các nút bên cạnh nút [Tất cả] là phân loại của các khóa học (Các nút này sẽ khác nhau tùy theo từng tổ chức sử dụng).</p>
                    <p>③ Nhất vào nút cài đặt để cài đặt việc hiển thị của các nút phân loại ở mục ②.</p>
                    <p>※ Các khóa học được hiển thị trong bảng số liệu không bao gồm các khóa học đã kết thúc (tức những khóa học bạn đã học xong và đã gửi [Yêu cầu kết thúc]).</p>
                    <p>&nbsp; Lúc này, nút [Gồm cả khóa học đã hoàn thành] ở trạng thái chưa được kích hoạt.</p>
                </div>
                <div><img src="/static\images\vi\newManual\myCourseManual-2.png" alt="" /></div>
                <div>
                    <p>Cài đặt việc hiển thị của các loại khóa học bằng cách kích hoạt các nút, hoặc nhấn [Bỏ chọn tất cả] rồi nhấn nút [Lưu].</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① Nhấn icon [Khóa học của tôi] ở phía dưới màn hình.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\my_course_1.png" alt="" /></div>
                <div><p>② Ở đây sẽ xuất hiện các khóa học bạn đã được thêm vào.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\my_course_2.png" alt="" /></div>
                <div><p>❖ Giải thích thêm về tính năng màn hình.</p></div>
                <div><p>1. Bạn muốn tham gia khóa học thì hãy nhấn vào khóa học cần tham gia như hình bên dưới.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\my_course_gt_1.png" alt="" /></div>
                <div><p>2. Bạn muốn xem các khóa học đã hoàn thành hãy nhấn vào nút [Gồm cả khóa học đã hoàn thành].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\my_course_gt_2.png" alt="" /></div>
                <div><p>3. Trường hợp bạn có nhiều khóa học, muốn tìm nhanh hãy nhấn vào danh mục bạn đang tham gia có thể giúp bạn tìm nhanh khóa học đó.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\my_course_gt_3.png" alt="" /></div>
                <div><p>4. Bạn chỉ muốn xem danh mục bạn đang tham gia, hãy làm các bước sau đây.</p></div>
                <div><p>4.1. Nhấn vào icon [Cài đặt].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\my_course_gt_4_1.png" alt="" /></div>
                <div><p>4.2. Chọn Danh mục bạn muốn và nhấn nút [Lưu].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\my_course_gt_4_2.png" alt="" /></div>
                <div><p>4.3. Ở đây chỉ hiển thị danh mục mà mà đã lưu ở bước trước.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\my_course_gt_4_3.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/myCourse_manual.vue